import ToastContent from './ToastContent';

import type { ToastComponentsMap } from './types';

const ToastComponents: ToastComponentsMap = {
  success: ToastContent,
  info: ToastContent,
  error: ToastContent,
};

export default ToastComponents;
